// GENERATED CODE - DO NOT EDIT
export const BillableTypeMap = {
    INSURANCE: 'INSURANCE',
    REBATE: 'REBATE',
    COUPON: 'COUPON',
    SAVINGS_CARD: 'SAVINGS_CARD',
    VOUCHER: 'VOUCHER',
    DEAL: 'DEAL',
};
//# sourceMappingURL=billable_type.js.map